import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var StarCircleIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsxs("g", {
                            clipPath: "url(#star-circle__a)",
                            children: [
                                _jsx("path", {
                                    d: "M15.155 18.33c-.25 0-.51-.07-.74-.2l-2.42-1.28-2.46 1.3c-.21.12-.49.2-.78.18-.27-.01-.54-.1-.77-.27a1.473 1.473 0 01-.58-1.49l.46-2.75-1.99-1.91c-.21-.21-.34-.45-.4-.71a1.454 1.454 0 011.18-1.78l2.78-.41 1.24-2.51c.11-.23.29-.44.52-.58.23-.15.49-.23.76-.23.27-.03.55.07.78.21.23.14.42.34.55.58L14.535 9l2.77.42c.25.03.51.15.73.32a1.468 1.468 0 01.47 1.5c-.07.27-.21.51-.42.7l-1.92 1.82.41 2.88c.05.22.02.5-.08.76s-.28.49-.51.66c-.23.17-.5.26-.79.27h-.08.04zm.22-1.95h.02-.02zm-3.38-1.58c.22 0 .43.05.63.13l1.85.98-.27-1.89c-.05-.15-.08-.31-.08-.47 0-.23.06-.47.17-.68.05-.1.12-.18.2-.26l1.45-1.38-1.96-.3c-.2-.02-.44-.11-.64-.26-.21-.15-.37-.36-.47-.59l-.86-1.73-.89 1.79a1.417 1.417 0 01-1.15.8l-1.9.28 1.44 1.38s.06.06.09.1c.15.19.25.41.3.64.04.2.03.41-.02.62l-.32 1.92 1.76-.93c.26-.12.47-.16.69-.16l-.02.01z"
                                }),
                                _jsx("path", {
                                    d: "M12.005 23.35c-3.03 0-5.88-1.18-8.02-3.32-2.15-2.15-3.33-5-3.33-8.03 0-3.03 1.18-5.88 3.32-8.03 2.14-2.15 5-3.32 8.03-3.32 3.03 0 5.88 1.18 8.02 3.32a11.27 11.27 0 013.32 8.02c0 3.03-1.18 5.88-3.32 8.02a11.27 11.27 0 01-8.02 3.32v.02zm0-20.7c-2.5 0-4.84.97-6.61 2.74A9.273 9.273 0 002.655 12c0 2.5.97 4.84 2.74 6.61a9.273 9.273 0 006.61 2.74c2.5 0 4.85-.97 6.61-2.74a9.384 9.384 0 002.74-6.61c0-2.46-.97-4.84-2.74-6.61a9.273 9.273 0 00-6.61-2.74z"
                                })
                            ]
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "star-circle__a",
                                children: _jsx("path", {
                                    d: "M0 0h24v24H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
StarCircleIcon.isCarinaIcon = true;
export default StarCircleIcon;
